'use client';
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "useSkeletonContextValues", {
    enumerable: true,
    get: function() {
        return useSkeletonContextValues;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const useSkeletonContextValues = (state)=>{
    const { animation, appearance } = state;
    const skeletonGroup = _react.useMemo(()=>({
            animation,
            appearance
        }), [
        animation,
        appearance
    ]);
    return {
        skeletonGroup
    };
};
